import reporting from '@/store/modules/reporting/reporting'
import reportingEdit from '@/store/modules/reporting/reporting-edit'
import reportingCreate from '@/store/modules/reporting/reporting-create'

export default {
  reporting,
  reportingEdit,
  reportingCreate,
}
